import { Suspense, useContext, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box } from '@mui/material/';
import { ToolContext } from '../core/context/ToolContext';
import { WebRoute } from "../core/webrouter/bizRoute";
import { SnakeLoader } from '../core/loader/SnakeLoader'
import { Logo } from '../core/global/Icons';
import { InstallPromotion } from './components/layouts/installation/InstallPromotion';
import { rqx } from '../core/request/API';
import { env } from '../core/Env';
import { ValidateCompanyMsg } from '../core/global/modal/ValidateCompanyMsg';
import { BrandLog } from '../core/global/BrandLog';
import { BankAccount } from './components/personalization/BankAcc'
import { TermsOfUse } from './components/personalization/TermsOfUse';
import { PerIndustry } from './components/personalization/perIndustry/Index'
import { getAllData, deleteIndexedDB } from '../core/global/db/Index';
import { VM } from '../core/VM';

const hcrmSession = JSON.parse(localStorage.getItem('hcrm_session'))
const tool_id = process.env.REACT_APP_TID_BIZ;
const __LOCATION = window.location.pathname;
const aloc = __LOCATION.split('/', 2)[1]
let view = VM();
export const Core = () => {
	const { tool_state, install_state, ubr_state, personalization_state } = useContext(ToolContext)
	const { tourData } = ubr_state;
	const { openBankForm, openTerms, bankForm, agreedTerms, hasAgreed, fromNavigation, open, selected, bankAgreed, industryLoader, toOpenBankForm } = personalization_state
	const __installer = () => {
		window.addEventListener('beforeinstallprompt', (e) => {
			e.preventDefault();
			install_state.prompt.set(e)
			installPromptHandler()
		});
	}

	const installPromptHandler = () => {
		setTimeout(() => {
			// install_state.ip.set({stat: true, prompt_type: 'first_prompt'})
		}, 2000);
	}

	useEffect(() => {
		BrandLog()
		const __init = async () => {
			// RUN AN API REQUEST HERE ( SAMPLE REQUESTS BELOW: )
			let ainfo = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/account/read`, { aid: hcrmSession.ainfo.aid })
			let pinfo = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/primeinfo/read`, { aid: hcrmSession.ainfo.aid })
			let uaccess = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/roleaccess/uap`, { aid: hcrmSession.ainfo.aid, tid: tool_id })
			let uaddress = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/location/assigned`, { aid: hcrmSession.ainfo.aid })
			await tool_state.__SESSION.set({ ainfo, pinfo, uaccess, uaddress })
			// SET STATES HERE ( SAMPLE STORING BELOW: )
			let d = new Date()
			d.setDate(d.getDate() + 30);
			localStorage.setItem('hcrm_session', JSON.stringify({ expiration: `${d.getMonth() + 1}${d.getUTCDate()}${d.getUTCFullYear()}`, ainfo: ainfo }))
			tool_state.userId.set(parseInt(window.atob(ainfo.aid).split('_')[1]))
			const getPersonalization = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/read`,
				{ tool_id: process.env.REACT_APP_TID_BIZ, user_id: parseInt(window.atob(ainfo.aid).split('_')[1]), ref: 'hrcPrsn' })
			tourData.set(getPersonalization)
			// FOR PERSONALIZATION PER INDUSTRY
			const p = await rqx.get(`<<tool>>/${env()}/industry/readIndustry`, {company_id: uaccess[0].company_id})
			let o = await getAllData('personalization', 'onboarding')
			if (p.length !== 0 ) {
				const industry = JSON.parse(p[0].industry);
				industry.sort((a, b) => a.id - b.id);
                selected.set(industry)
                if (uaccess?.[0]?.role_id === 0) {
                    const existingIndustry = JSON.parse(p[0].industry)
                    const normalizeIndustry = (data) => {
                        if (!data) return []
                        if (Array.isArray(data)) {
                            return data.map(i =>
                            typeof i === 'object' ? { id: Number(i.id) } : { id: Number(i) }
                            )
                        }
    
                        if (typeof data === 'object') {
                            return [{ id: Number(data.id) }]
                        }
    
                        if (typeof data === 'string') {
                            return data
                            .split(',')
                            .map(i => ({ id: Number(i.trim()) }))
                        }
                        return [{ id: Number(data) }]
                    }
                    open.set({welcome: false, todo: false})
                    if (o.length !== 0) {
                        const newIndustry = normalizeIndustry(o[0].industry)
    
                        const mergedIndustry = [
                            ...existingIndustry,
                            ...newIndustry.filter(
                            ni => !existingIndustry.some(ei => ei.id === ni.id)
                        )
                        ]
                        if (mergedIndustry.length === existingIndustry.length) {
                            tool_state.prefetch.set(true)
                            return
                        }
                        const body = {
                            company_id: uaccess[0].company_id,
                            user_id: parseInt(window.atob(hcrmSession.ainfo.aid).split('_')[1]),
                            industry: mergedIndustry
                        }
                        const res = await rqx.post(`<<tool>>/${env()}/industry/updateIndustry`, body)
                        if (res.message === 'success') {
                            await deleteIndexedDB('personalization')
                        }
                        selected.set(mergedIndustry)
                    }
                }
			} else {
				if (o.length !== 0) {
					selected.set(o[0].industry)
					open.set({welcome: true, todo: false})
					industryLoader.set(true)
                    if (uaccess?.[0]?.role_id === 0) {
                        const body = {
                            company_id: uaccess[0].company_id,
                            user_id: parseInt(window.atob(hcrmSession.ainfo.aid).split('_')[1]),
                            industry: o[0].industry
                        }
                        const res = await rqx.post(`<<tool>>/${env()}/industry/createIndustry`, body)
                        if (res.message === 'success') {
                            industryLoader.set(false)
                            open.set({welcome: false, todo: false})
                            await deleteIndexedDB('personalization')
                        }
                    }
				} else {
                    if (uaccess?.[0]?.role_id === 0) {
                        open.set({welcome: true, todo: false})
                    }
				}
			}
			tool_state.prefetch.set(true)
            // FOR READBANKACCOUNT
			const x = await rqx.get(`<<biz>>/${env()}/biz/bank/readBankAccount`, { company_id: uaccess[0].company_id, user_id: parseInt(window.atob(ainfo.aid).split('_')[1]) })
             // FOR AGREMENT
			const t = await rqx.get(`<<tool>>/${env()}/user/terms_agree`, { company_id: uaccess[0].company_id, })
			// FOR SALES CHECKER
			const sales_checker = await rqx.get(`<<tool>>/${env()}/business/has_any_sales`, { company_id: uaccess[0].company_id, })
			if (x !== 0) bankAgreed.set(true)
			if (x === 0) {
				if (sales_checker) {
					openBankForm.set(true)
					toOpenBankForm.set(true)
				}
				hasAgreed.set(Boolean(t))
				agreedTerms.set(Boolean(t))
			} else if (!t) {
				bankForm.set(p => ({ ...p, disabled: x.length !== 0 }))	
				openTerms.set(true)
				fromNavigation.set(true)
				// openBankForm.set(true)
			}
			// RUN PWA INSTALLATION PROMPT HANDLER
			// installPromptHandler()
		}
		// SET FOR DEFAULT LANDING PAGE
		if (__LOCATION === '/' || __LOCATION === '/psl') {
			window.location.href = '/campaign/creative-brief?mode=list'
		}
		const readPrsnlztn = async() => {
			let o = await getAllData('personalization', 'onboarding')
			if (hcrmSession === null) {
				if (o.length !== 0) {
					selected.set(o[0].industry)
				}
				open.set({welcome: true, todo: false})
			}
		}
		
		if (hcrmSession !== null) {
			__installer()
			__init()
		} else {
            // FOR PERSONALIZATION PER INDUSTRY
            readPrsnlztn()
			setTimeout(() => {
				// SET STATES HERE ( SAMPLE STORING BELOW: )
				tool_state.prefetch.set(true)

				// RUN PWA INSTALLATION PROMPT HANDLER

				installPromptHandler()
			}, 1000);
		}
		console.log(`HRC Business Version V2.4.99 is running`);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return (
		<Box width="100%" height="100%" >
			{
				tool_state.prefetch.data ? (
					<Router>
						<Suspense fallback={
							<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
								<Logo size={60} />
								<Box mt={4}>
									<SnakeLoader size="1rem" bg="#006400" distance="0.3rem" />
								</Box>
							</Box>
						}>
							<WebRoute />
							{
								(openBankForm.data && aloc !== 'ws' && tool_state?.__SESSION?.data?.uaccess?.[0]?.role_id === 0) &&
								<BankAccount />
							}
							{
								(!openBankForm.data && aloc !== 'ws' && openTerms.data) &&
								<TermsOfUse />
							}
							{
								( aloc !== 'ws') && view === '' &&
									<PerIndustry />
							}
                            {/* <ModalPromoMsg /> */}
						</Suspense>
					</Router>
				) : (
					<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
						{(__LOCATION === '/website/mobile' || __LOCATION === '/website/tablet' || __LOCATION === '/website/desktop') ?
							<>
							    Property
								<Box mt={4}>
									<SnakeLoader size="0.6rem" bg="#006400" distance="0.3rem" />
								</Box>
							</>
							:
							<>
								<Logo size={60} />
								<Box mt={4}>
									<SnakeLoader size="1rem" bg="#006400" distance="0.3rem" />
								</Box>
							</>
						}
					</Box>
				)
			}
			<InstallPromotion install_state={install_state} tool_state={tool_state} />
			<ValidateCompanyMsg />
		</Box>
	)
}